import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import vueHeadful from "vue-headful";
import store from "@/store/store";
import routes from "./routes";
import BootstrapVue from "bootstrap-vue";
import Chat from 'vue-beautiful-chat';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Chat)


const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    window.scrollTo(0, 0);
  },
});
Vue.component("vue-headful", vueHeadful);
router.beforeEach((to, from, next) => {

  // if any of the routes in ./router.js has a meta named 'requiresAuth: true'
  // then check if the user is logged in before routing to this path:
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({ name: "login" });
    } else {
      next();
    }
  }  else if (to.matched.some((record) => record.meta.requiresApp)) {
    var code=''
    if (to.name == 'merchant') {
      code='MP'
    }else if(to.name == 'echeck'){
      code='EC'
    }else if(to.name == 'crypto'){
      code='CR'
    }else if(to.name == 'chargeback'){
      code='CS'
    }
    var access='';
    if (!store.getters.loggedIn) {
      next({ name: "login" });
    } else {
      store.dispatch("hasApp",code).then((r) => {
        access = r
        if(access){
          next()
        }else{
          next({ name: "userapps" })
        }
      }).catch((r) =>{
        access = r
        next({ name: "userapps" })
      })
    }
  } else if (to.matched.some((record) => record.meta.requiresLogged)) {
    // else if any of the routes in ./router.js has a meta named 'requiresLogged: true'
    // then check if the user is logged in; if true continue to home page else continue routing to the destination path
    // this comes to play if the user is logged in and tries to access the login/register page
    if (store.getters.loggedIn) {
      next({ name: "home" });
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.requiresAdmin)) {
    // else if any of the routes in ./router.js has a meta named 'requiresAdmin: true'
    // then check if the user is superuser; if true continue to home page else continue routing to the destination path
    store.dispatch("hasAccess").then(() => {
      next()
    }).catch(() =>{
      next({ name: "home" });
    } )
  } else if (to.matched.some((record) => record.meta.emailconfirm)) {
    store
      .dispatch("emailConfirm", {
        key: to.params.key
      })
      .then(res => {
        router.push({ name: "login", query: { message: "confirmed" } });
      })
      .catch(error => {
        next();
      });
  }
  else {
    next();
  }
});
new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");

//Adding comment for commit
